exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-inline .multiselect {\n    display: inline-block;\n    width: auto;\n}\n", ""]);

// exports
